import React, { useRef, useState, useEffect } from "react";
import { HubConnectionBuilder } from "@aspnet/signalr";
import { SoundNotification } from "./components/SoundNotification";
import { Layout } from "./components/Layout";
import NotAuthorized from "../../components/NotAuthorized";
import { getKey } from "../../helpers/UrlHelper";
import { clientTypeConstants } from "../../interaction/constants/clientType.constants";
import { init } from "../../components/EventLabel2/EventLabel2";
/* import { videoCallConstants } from "../../constants/videoCall.constants"; */
import { getUserInformation, isUsingChrome } from "../../helpers/browser.helper";
import { meetingService } from "../../services/meeting/meeting.service";
import { videoCallConstants } from "../constants/videoCall.constants";
import { deepClone } from "../../helpers/objectHelper";
import { ClientConnectionFallback } from "../../digitalArena/utils/ClientConnectionFallback";
import { ConnectionStatus } from "../../digitalArena/components/fallbacks/ConnectionStatus";
import { arrayHelper } from "../../helpers/arrayHelper";

const defaultState = {
  page: "DASHBOARD",
  clientKey: null,
  subPath: null,
  active: true,
  eventCode: null,
  exhibitorId: null,
  connecting: true,
  orderList: [],
  connectionList: [],
  notAuthorized: false,
  forceDisc: false,
  clientName: "",
  exhibitorSettings: [],
  chat: [],
  exhibitorName: "",
  logList: [],
  targetPerson: null,
  lang: "swe",
  scroll: false,
  visited: [],
  deleteList: [],
  nonAvailablePersons: [],
  videoCallTarget: null,
  videoCallActive: false,
  videoCallResponse: null,
  callId: null,
  enableVideoMeeting: false,
  isCalling: null,
  selectedChat: null,
  VideoCallTimeout: 15,
  incommingCallSoundOn: false,
  ringingSoundOn: false,
  enableChat: true,
  targetShortCut: null,
  chatConnections: [],
  meetingCode: null,
  messageSoundOn: false,
  exhibitorsHosts: [],
  profileBio: "",
  graphData: [],
  peopleFilter: "ATTENDEES",
  ip: "",
  profileImage: "",
  chrome: false,
};

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

var counter = null;

export const Backoffice = (props) => {
  const [state, setState] = useState({ ...defaultState });
  const [countdown, setCountdown] = useState(0);

  const stateRef = useRef();

  const callTimeoutRef = useRef({});
  const hubConnectionRef = useRef();

  const graphDataTimerRef = useRef();
  const connectionTimerRef = useRef();
  const chatConnectionRef = useRef();
  const visitorStatsTimerRef = useRef();

  const orderListTimerRef = useRef();

  const prevState = usePrevious(state);

  stateRef.current = state;

  useEffect(() => {
    const { ip, exhibitorId } = stateRef.current;
    if (ip && exhibitorId) {
      connectToHub();
    }
  }, [state.exhibitorId, state.ip]);

  useEffect(() => {
    const { location, match } = props;

    const chrome = isUsingChrome();

    meetingService.getUserIp().then((ip) => {
      setState({ ...stateRef.current, ip });
    });

    let exhibitorId = parseInt(match.params.id, 36);

    const params = new URLSearchParams(location.search);
    const clientKey = params.get(getKey("clientkey", params));
    const lang = params.get(getKey("lang", params));

    document.body.style.overflow = "hidden";

    setState({
      ...stateRef.current,
      clientKey,
      lang,
      exhibitorId,
      chrome,
    });
    return () => {
      if (counter) {
        clearInterval(counter);
      }
      hubConnectionRef.current.off("onSendChatMessage", onSendChatMessage);
      hubConnectionRef.current.off("onChatMessageReceived", onReceiveMessage);
    };
  }, []);

  useEffect(() => {
    const { connected, connecting, dismissConnectionLoss, forceDisc } = stateRef.current;
    if (connected == false && !forceDisc && prevState.connected == true && connecting == false) {
      tryReconnect();
      counter = setInterval(() => {
        setCountdown((prevCount) => prevCount + 1);
      }, 1000);
    } else if (countdown >= 60 && !connected && !forceDisc && prevState.connected == false) {
      setCountdown(0);
      setState({ ...stateRef.current, connecting: false });
      tryReconnect();
    } else if (connected == true && prevState.connected == false && !connecting && hubConnectionRef.current && hubConnectionRef.current.connectionState == 1) {
      if (counter) clearInterval(counter);
      setCountdown(0);
    }
  }, [state.connected, state.connecting, state.forceDisc, countdown]);

  useEffect(() => {
    if (hubConnectionRef.current) {
      hubConnectionRef.current.on("onGetActiveConnections", onGetActiveConnections);
      hubConnectionRef.current.on("onGetVisitorStats", onGetVisitorStats);
      hubConnectionRef.current.on("onGetActiveChatConnections", onGetActiveChatConnections);
      hubConnectionRef.current.on("onGetExhibitorVisitorStats", onGetExhibitorVisitorStats);
      hubConnectionRef.current.on("onGetOrderList", onGetOrderList);
      hubConnectionRef.current.on("onHostChatInteraction", onHostChatInteraction);
    }

    return () => {
      if (hubConnectionRef.current) {
        hubConnectionRef.current.off("onGetActiveConnections", onGetActiveConnections);
        hubConnectionRef.current.off("onGetVisitorStats", onGetVisitorStats);
        hubConnectionRef.current.off("onGetActiveChatConnections", onGetActiveChatConnections);
        hubConnectionRef.current.off("onGetExhibitorVisitorStats", onGetExhibitorVisitorStats);
        hubConnectionRef.current.off("onGetOrderList", onGetOrderList);
        hubConnectionRef.current.off("onHostChatInteraction", onHostChatInteraction);
      }
    };
  });

  function tryReconnect() {
    const { connecting, connected } = stateRef.current;
    if (!connecting && !connected) {
      setState({ ...stateRef.current, loading: true, connecting: true });
      connectToHub();
    }
  }



  function connectToHub() {
    const { clientKey, exhibitorId, ip } = stateRef.current;
    setState({ ...stateRef.current, forceDisc: false });

    if (!hubConnectionRef.current) hubConnectionRef.current = new HubConnectionBuilder().withUrl("./ihub").build();

    hubConnectionRef.current
      .start()
      .then(() => {
        hubConnectionRef.current.on("onExpoHandshake", onHandshake);

        hubConnectionRef.current.on("onGetChatMessage", (chat) => {
          console.table(chat);
          setState({ ...stateRef.current, chat });
        });

        hubConnectionRef.current.on("onChatMessageReceived", onReceiveMessage);
        hubConnectionRef.current.on("onSendChatMessage", onSendChatMessage);
        hubConnectionRef.current.on("onLikeMessage", onLike);
        hubConnectionRef.current.on("onInitChat", getChat);



        hubConnectionRef.current.on("onVideoRequest", onVideoRequest);
        hubConnectionRef.current.on("onReleased", onReleased);
        hubConnectionRef.current.on("onOccupied", onOccupied);
        hubConnectionRef.current.on("onVideoClosed", onVideoClosed);
        hubConnectionRef.current.on("onVideoResponse", onVideoResponse);
        hubConnectionRef.current.on("onGetNoneAvailableCallers", (nonAvailablePersons) => {
          setState({ ...stateRef.current, nonAvailablePersons });
        });
        /*         hubConnectionRef.current.on("onGetVisitorStats", onGetVisitorStats); */

        hubConnectionRef.current.on("onGetExhibitorSettings", onGetExhibitorSettings);
        /*         hubConnectionRef.current.on("onGetActiveConnections", onGetActiveConnections); */

        hubConnectionRef.current.on("onSettingsSaved", onSettingsSaved);
        hubConnectionRef.current.on("onMessageSeen", onMessageSeen);
        hubConnectionRef.current.on("onHostUpdate", onHostUpdate);
        hubConnectionRef.current.on("onGetActivityLog", onGetActivityLog);
        hubConnectionRef.current.on("onForceDisconnect", onForceDisconnect);

        hubConnectionRef.current.on("onGetExhibitorHosts", (exhibitorsHosts) => {
          setState({ ...stateRef.current, exhibitorsHosts });
        });

        hubConnectionRef.current.onclose(() => {
          setState({ ...stateRef.current, connected: false });
        });

        let userInfo = { ...getUserInformation(), ipAddress: ip };
        const handshakeObj = {
          exhibitorId,
          eventId: 0,
          clientType: clientTypeConstants.INTERACTION_EXHIBITOR_HOST,
          clientKey,
          userGuid: null,
          userInfo,
        };

        hubConnectionRef.current.invoke("expoHandshake", handshakeObj).catch((err) => {
          console.error(err);
        });
      })
      .catch((error) => console.error(error));
  }

  function onHandshake(response) {
    const { success, companyName, clientName, clientKey, exhibitorName, eventId, eventCode, profileImage, profileBio, lang } = response;

    const { exhibitorId } = stateRef.current;

    if (response.success) {
      setState({
        ...stateRef.current,
        ...response,
        connected: true,
        connecting: false,
        lang: stateRef.current.lang || lang,
      });

      init(eventId, "Exhibitor.Admin", stateRef.current.lang || lang);

      hubConnectionRef.current
        .invoke("getActiveConnections", eventId, exhibitorId, [clientTypeConstants.INTERACTION_EXHIBITOR_HOST, clientTypeConstants.INTERACTION_EXHIBITOR_VISITOR])
        .catch((err) => console.error(err));

      hubConnectionRef.current.invoke("getOrderList", eventId).catch((err) => console.error(err));

      getChat();

      hubConnectionRef.current.invoke("getExhibitorSettings", exhibitorId).catch((err) => console.error(err));

      hubConnectionRef.current.invoke("getActiveChatConnections", eventId).catch((err) => console.error(err));

      hubConnectionRef.current.invoke("getVisitorStats", eventId, exhibitorId).catch((err) => console.error(err));

      hubConnectionRef.current.invoke("getActivityLog", exhibitorId, clientKey).catch((err) => console.error(err));

      hubConnectionRef.current.invoke("getExibitorVisitorStats", exhibitorId);

      hubConnectionRef.current.invoke("getNoneAvailableCallers", exhibitorId).catch((err) => { });
      if (!connectionTimerRef.current) {
        connectionTimerRef.current = setInterval(() => {
          if (!stateRef.current.connected || !hubConnectionRef.current || hubConnectionRef.current.connectionState != 1) return;
          hubConnectionRef.current
            .invoke("getActiveConnections", eventId, exhibitorId, [clientTypeConstants.INTERACTION_EXHIBITOR_HOST, clientTypeConstants.INTERACTION_EXHIBITOR_VISITOR])
            .catch((err) => console.error(err));
        }, 5000);
      }
      if (!graphDataTimerRef.current) {
        graphDataTimerRef.current = setInterval(() => {
          if (!stateRef.current.connected || !hubConnectionRef.current || hubConnectionRef.current.connectionState != 1) return;
          hubConnectionRef.current.invoke("getVisitorStats", eventId, exhibitorId).catch((err) => console.error(err));
        }, 5000);
      }
      if (!visitorStatsTimerRef.current) {
        visitorStatsTimerRef.current = setInterval(() => {
          if (!stateRef.current.connected || !hubConnectionRef.current || hubConnectionRef.current.connectionState != 1) return;
          hubConnectionRef.current.invoke("getExibitorVisitorStats", exhibitorId).catch((err) => console.error(err));
        }, 15000);
      }
      if (!orderListTimerRef.current) {
        orderListTimerRef.current = setInterval(() => {
          if (!stateRef.current.connected || !hubConnectionRef.current || hubConnectionRef.current.connectionState != 1) return;
          hubConnectionRef.current.invoke("getOrderList", eventId).catch((err) => console.error(err));
        }, 60000);
      }
      if (!chatConnectionRef.current) {
        chatConnectionRef.current = setInterval(() => {
          if (!stateRef.current.connected || !hubConnectionRef.current || hubConnectionRef.current.connectionState != 1) return;
          hubConnectionRef.current.invoke("getActiveChatConnections", eventId).catch((err) => console.error(err));
        }, 30000);
      }
    } else {
      console.error(response.message);
    }
  }

  function onGetActivityLog(logList) {
    if (!Array.isArray(logList)) {
      let logListCopy = Array.from(stateRef.current.logList);
      logListCopy = [logList].concat(logList);
      setState({ ...stateRef.current, logListCopy });
    } else setState({ ...stateRef.current, logList });
  }

  function navigate(page, selectedChat = null) {
    setState({
      ...stateRef.current,
      page,
      /*   targetConversation, */
      selectedChat: selectedChat || stateRef.current.selectedChat,
    });
  }

  function onGetExhibitorSettings(exhibitorSettings) {
    const enableChat = getSetting("EnableChat")?.value2 == "True" ? true : false;

    const enableVideoMeeting = getSetting("EnableVideoMeeting")?.value2 == "True" ? true : false;
    const videoCallTimeout = getSetting("VideoCallTimeout")?.value2 ?? 15;

    setState({
      ...stateRef.current,
      exhibitorSettings,
      enableChat,
      enableVideoMeeting,
      videoCallTimeout,
    });
  }

  function videoRequestOnTimeout(target, callId) {
    const { videoCallActive, clientKey, exhibitorId, isCalling } = stateRef.current;

    if (videoCallActive == false && target != clientKey && isCalling) {
      videoRequestResponse(false, target, callId);
    }
  }

  function onVideoRequest({ target, meetingCode, callId }) {
    const { videoCallActive, clientKey, exhibitorId, isCalling, videoCallTimeout } = stateRef.current;
    if (!isCalling && target != clientKey) {
      setState({
        ...stateRef.current,
        isCalling: target,
        callId: callId,
        incommingCallSoundOn: true,
      });

      callTimeoutRef.current[target] = setTimeout(() => videoRequestOnTimeout(target, callId), (parseInt(videoCallTimeout) || 15) * 1000);
    } else {
      setState({ ...stateRef.current, callId });
    }
    setState({ ...stateRef.current, meetingCode });
  }

  function onVideoClosed() {
    const { videoCallActive } = stateRef.current;
    if (videoCallActive) {
      setState({
        ...stateRef.current,
        videoCallActive: false,
        videoCallResponse: videoCallConstants.TARGET_HANGUP,
        callId: null,
      });
      setTimeout(() => setState({ ...stateRef.current, videoCallTarget: null }), 2000);
    }
  }

  function closeVideoCall(target) {
    const { callId, exhibitorId, clientKey } = stateRef.current;
    setState({
      ...stateRef.current,
      videoCallActive: false,
      videoCallResponse: videoCallConstants.SELF_HANGUP,
      ringingSoundOn: false,
    });

    setTimeout(() => setState({ ...stateRef.current, videoCallTarget: null }), 2000);
    if (!stateRef.current.connected || !hubConnectionRef.current || hubConnectionRef.current.connectionState != 1) return;
    hubConnectionRef.current.invoke("videoCallClosed", clientKey, target, exhibitorId, callId).catch((err) => {
      console.error(err);
    });
  }

  function onVideoResponse({ target, response, meetingCode, callId }) {
    const { isCalling, videoCallActive, videoCallTarget, clientKey } = stateRef.current;

    if (response && response != "SELF_HANGUP") {
      window.addEventListener("onclose", () => {
        if (stateRef.current.videoCallActive) {
          closeVideoCall(stateRef.current.videoCallTarget);
        }
        if (isCalling) {
          videoRequestResponse(false, isCalling, callId);
        }
      });
      window.addEventListener("beforeunload", () => {
        if (videoCallActive) {
          closeVideoCall(videoCallTarget);
        }
        if (isCalling) {
          videoRequestResponse(false, isCalling, callId);
        }
      });

      setState({
        ...stateRef.current,
        videoCallActive: true,
        videoCallTarget: target,
        callId,
        ringingSoundOn: false,
        incommingCallSoundOn: false,
      });
    } else {
      let res = videoCallConstants.CALL_DENIED;

      if (response == "SELF_HANGUP") {
        res = videoCallConstants.SELF_HANGUP;
      }

      if (isCalling != target) {
        setState({
          ...stateRef.current,
          videoCallResponse: res,
          ringingSoundOn: false,
        });
        setTimeout(() => setState({ ...stateRef.current, videoCallTarget: null }), 2000);
      } else {
        setState({
          ...stateRef.current,
          videoCallResponse: null,
          videoCallTarget: null,
          isCalling: false,
          ringingSoundOn: false,
          incommingCallSoundOn: false,
        });
      }
    }
  }

  function videoRequestResponse(answer = true, target, callId, directed = false) {
    if (!stateRef.current.connected || !hubConnectionRef.current || hubConnectionRef.current.connectionState != 1) return;

    const { exhibitorId, clientKey, page } = stateRef.current;
    clearTimeout(callTimeoutRef.current[target]);

    const newState = deepClone(stateRef.current);

    newState.isCalling = null;
    newState.incommingCallSoundOn = false;
    newState.ringingSoundOn = false;

    if (answer == true) {
      newState.videoCallActive = true;
      newState.videoCallTarget = target;
      newState.callId = callId;
      newState.page = "CHAT";
      newState.selectedChat = null;
    }

    if (directed) {
      hubConnectionRef.current.invoke("selfHangup", target, clientKey, parseInt(exhibitorId), callId);
    } else {
      hubConnectionRef.current.invoke("videoRequestResponse", target, clientKey, parseInt(exhibitorId), answer, callId);
    }

    setState(newState);
  }

  function onReleased(res) {
    let nonAvailablePersons = Array.from(stateRef.current.nonAvailablePersons);
    nonAvailablePersons = nonAvailablePersons.filter((h) => h != res);
    setState({ ...stateRef.current, nonAvailablePersons });
  }

  function onOccupied(res) {
    const nonAvailablePersons = Array.from(stateRef.current.nonAvailablePersons);
    nonAvailablePersons.push(res);
    setState({ ...stateRef.current, nonAvailablePersons });
  }

  function videoRequest(target) {
    if (!stateRef.current.connected || !hubConnectionRef.current || hubConnectionRef.current.connectionState != 1) return;
    const { exhibitorId, clientKey } = stateRef.current;

    hubConnectionRef.current.invoke("videoRequest", target, clientKey, parseInt(exhibitorId)).catch((err) => {
      console.error(err);
    });

    setState({
      ...stateRef.current,
      page: "CHAT",
      videoCallTarget: target,
      videoCallResponse: null,
      ringingSoundOn: true,
    });
  }
  const selectChat = (target) => {
    const chat = stateRef.current.chat.find((c) => c.target == target);
    if (chat) {
      setMessageSeen(chat);
    }
    setState({ ...stateRef.current, selectedChat: target, page: "CHAT" });
  };

  function onMessageSeen(target) {
    const chat = Array.from(stateRef.current.chat);
    chat.map((c) => {
      if (c.target == target) {
        c.messages.map((m) => {
          c.seen = true;
          m.seen = true;
        });
      }
    });
    setState({ ...stateRef.current, chat });
  }
  function getSetting(name) {
    const { exhibitorSettings } = stateRef.current;
    const setting = exhibitorSettings?.find((s) => s.name == name);
    return setting;
  }

  function setMessageSeen(chat) {
    if (!stateRef.current.connected || !hubConnectionRef.current || hubConnectionRef.current.connectionState != 1) return;
    const { clientKey, eventId } = stateRef.current;
    const notReadMessage = chat.messages.find((c) => c.seen == false && c.receiver == clientKey);
    if (notReadMessage) {
      hubConnectionRef.current.invoke("setMessageSeen", eventId, notReadMessage.receiver, notReadMessage.sender, null).catch((err) => { });
    }
  }

  function onHostChatInteraction(res) {
    const { message, senderLastName, senderFirstName, inserted, sender } = res;
    const chat = Array.from(stateRef.current.chat);
    const requestedChat = chat.find((c) => c.target == "EXPO");

    if (requestedChat) {
      let index = chat.indexOf(requestedChat);

      if (index > -1) {
        if (chat[index].messages.find((c) => c.interactionChatId == res.interactionChatId)) return;
        chat[index].messages.push(res);
        chat[index].previewText = message;
        chat[index].previewPreFix = res.senderFirstName + " " + senderLastName;
        chat[index].lastChange = inserted;
      }
    }

    setState({ ...stateRef.current, chat });
  }

  function onReceiveMessage(res) {
    const { chatSelected } = stateRef.current;
    const { message, senderLastName, senderFirstName, inserted, sender } = res;
    const chat = Array.from(stateRef.current.chat);
    const requestedChat = chat.find((c) => c.target == sender);

    if (requestedChat) {
      let index = chat.indexOf(requestedChat);

      if (index > -1) {
        if (chat[index].messages.find((c) => c.interactionChatId == res.interactionChatId)) return;
        chat[index].messages.push(res);
        chat[index].previewText = message;
        chat[index].previewPreFix = res.senderFirstName + " " + senderLastName;
        chat[index].lastChange = inserted;
      }
    } else {
      chat.push({
        lastChange: inserted,
        messages: [res],
        previewText: message,
        previewPreFix: senderFirstName + " " + senderLastName,
        target: sender,
        seen: false,
      });
    }
    if ((chatSelected && chatSelected.badgeNo != res.sender) || !chatSelected) {
      setState({ ...stateRef.current, messageSoundOn: true });
      setTimeout(() => setState({ ...stateRef.current, messageSoundOn: false }), 2000);
    }
    setState({ ...stateRef.current, chat, scroll: true });
  }

  function onSendChatMessage(res) {
    const { chatSelected, clientKey, chat } = stateRef.current;
    const { message, senderLastName, senderFirstName, inserted, sender, receiver } = res;
    const requestedChat = chat.find((c) => c.target == receiver);

    if (requestedChat) {
      let index = chat.indexOf(requestedChat);

      if (index > -1) {
        if (chat[index].messages.find((c) => c.interactionChatId == res.interactionChatId)) return;
        chat[index].messages.push(res);
      }

      chat[index].previewText = message;
      chat[index].previewPreFix = res.sender == clientKey ? "You" : senderFirstName + " " + senderLastName;
      chat[index].lastChange = inserted;
    } else {
      chat.push({
        lastChange: inserted,
        messages: [res],
        previewText: message,
        previewPreFix: "",
        target: receiver,
        seen: false,
      });
    }
    setState({ ...stateRef.current, chat, scroll: true });
  }

  function getChat() {
    if (!stateRef.current.connected || !hubConnectionRef.current || hubConnectionRef.current.connectionState != 1) return;
    const { clientKey, exhibitorId, eventId } = stateRef.current;
    hubConnectionRef.current.invoke("getChatMessages", eventId, clientKey, `Expo:${exhibitorId}`, false);
  }
  function onLike(messageId) {
    const { chat } = stateRef.current;

    chat.map((c) => {
      c.messages.map((m) => {
        if (m.interactionChatId == messageId) {
          if (m.likes == null) m.likes = 0;
          m.likes += 1;
        }
      });
    });

    setState({ ...stateRef.current, chat });
  }

  function like(messageId) {
    if (!stateRef.current.connected || !hubConnectionRef.current || hubConnectionRef.current.connectionState != 1) return;
    const { exhibitorId, selectedChat } = stateRef.current;
    hubConnectionRef.current.invoke("like", messageId, selectedChat, exhibitorId);
  }

  function savePersonalSettings(bio, image) {
    const { exhibitorId, clientKey } = stateRef.current;

    //Rewrite this!!!!!

    if (image) {
      hubConnectionRef.current.invoke("savePersonalSettings", exhibitorId, clientKey, "ProfileImage", image);
    }

    if (bio) {
      hubConnectionRef.current.invoke("savePersonalSettings", exhibitorId, clientKey, "ProfileBio", bio);
    }
  }

  function onHostUpdate({ badgeNo, name, value }) {
    const { clientKey } = stateRef.current;
    if (badgeNo == clientKey) {
      if (name == "ProfileImage") setState({ ...stateRef.current, profileImage: value });
      else if (name == "ProfileBio") setState({ ...stateRef.current, profileBio: value });
    }
  }

  function onForceDisconnect(res) {
    if (res === "NOT_AUTHORIZED") {
      setState({ ...stateRef.current, notAuthorized: true, connected: false });
      hubConnectionRef.current.stop();
    } else {
      hubConnectionRef.current.stop();
      setState({ ...stateRef.current, forceDisc: true, connected: false });
    }
  }

  function onGetVisitorStats(list) {
    if (arrayHelper.compareChanges(stateRef.current.graphData, list, "count")) {
      setState({ ...stateRef.current, graphData: list });
    }
  }

  function onGetActiveConnections(list) {
    const { clientKey } = stateRef.current;
    if (
      arrayHelper.compareChanges(
        stateRef.current.connectionList.filter((c) => c.clientKey != clientKey),
        list.filter((c) => c.clientKey != clientKey),
        "clientKey"
      )
    ) {
      const cl = Array.from(list);
      setState({
        ...stateRef.current,
        connectionList: cl.filter((c) => c.clientKey != clientKey),
      });
    }
  }
  function onGetActiveChatConnections(list) {
    const { clientKey } = stateRef.current;
    if (
      arrayHelper.compareChanges(
        stateRef.current.chatConnections.filter((c) => c.clientKey != clientKey),
        list.filter((c) => c.clientKey != clientKey),
        "clientKey"
      )
    ) {
      const cl = Array.from(list);
      setState({
        ...stateRef.current,
        chatConnections: cl.filter((c) => c.clientKey != clientKey),
      });
    }
  }

  function onGetExhibitorVisitorStats(list) {
    const { clientKey } = stateRef.current;

    if (
      arrayHelper.compareChanges(
        stateRef.current.visited.filter((c) => c.badgeNo != clientKey),
        list.filter((c) => c.badgeNo != clientKey),
        "lastVisit"
      )
    ) {
      const cl = Array.from(list);

      setState({
        ...stateRef.current,
        visited: cl.filter((c) => c.badgeNo != clientKey),
      });
    }
  }

  function onGetOrderList(list) {
    const { clientKey } = stateRef.current;

    if (
      arrayHelper.compareChanges(
        stateRef.current.orderList.filter((c) => c.badgeNo != clientKey),
        list.filter((c) => c.badgeNo != clientKey),
        "badgeNo"
      )
    ) {
      const cl = Array.from(list);
      setState({
        ...stateRef.current,
        orderList: cl.filter((c) => c.badgeNo != clientKey),
      });
    }
  }

  function deleteSettings(id) {
    const exhibitorSettings = Array.from(stateRef.current.exhibitorSettings);
    const setting = exhibitorSettings.find((e) => e.exhibitorSettingId == id);
    if (!setting) return;
    const index = exhibitorSettings.indexOf(setting);
    if (index == -1 || !exhibitorSettings[index]) return;
    let deleteList = Array.from(stateRef.current.deleteList);
    if (deleteList.find((d) => d.exhibitorSettingId == id)) {
      deleteList = deleteList.filter((d) => {
        return d.exhibitorSettingId != id;
      });
    } else {
      deleteList.push(setting);
    }
    setState({ ...stateRef.current, deleteList });
  }
  function editSettings(id, path, value) {
    const exhibitorSettings = Array.from(stateRef.current.exhibitorSettings);
    const setting = exhibitorSettings.find((e) => e.exhibitorSettingId == id);
    if (!setting) return;
    const index = exhibitorSettings.indexOf(setting);
    if (index == -1) return;
    exhibitorSettings[index][path] = value;
    setState({ ...stateRef.current, exhibitorSettings });
  }

  function onSettingsSaved(exhibitorSettings) {
    setState({ ...stateRef.current, exhibitorSettings });
  }

  const saveSettings = () => {
    if (!stateRef.current.connected || !hubConnectionRef.current || hubConnectionRef.current.connectionState != 1) return;
    const { exhibitorSettings, deleteList = null, exhibitorId, eventId } = stateRef.current;

    const addList = exhibitorSettings.filter((e) => e.exhibitorSettingId < 0) || [];
    const settings = exhibitorSettings.filter((e) => e.exhibitorSettingId > 0 && !deleteList.find((d) => d.exhibitorSettingId == e.exhibitorSettingId)) || [];

    try {
      hubConnectionRef.current.invoke("editExpoSettings", exhibitorId, settings, addList, deleteList);
    } catch (error) {
      console.error(error);
    }
  };

  function goToBooth() {
    const { clientKey, exhibitorId, lang } = stateRef.current;
    window.open(
      window.location.href.includes("localhost")
        ? `/booth/${exhibitorId.toString(36)}?clientkey=${clientKey}&lang=${lang}`
        : `/interaction/booth/${exhibitorId.toString(36)}?clientkey=${clientKey}&lang=${lang}`,
      "_blank"
    );
  }
  function goToMainRoom() {
    const { clientKey, exhibitorId, lang, eventCode } = stateRef.current;
    window.open(window.location.href.includes("localhost") ? `/digitalmeeting/${eventCode}?clientkey=${clientKey}` : `/interaction/digitalmeeting/${eventCode}?clientkey=${clientKey}`, "_blank");
  }

  function addSetting(s) {
    const exhibitorSettings = Array.from(stateRef.current.exhibitorSettings);
    exhibitorSettings.push(s);
    setState({ ...stateRef.current, exhibitorSettings });
  }
  const {
    connected,
    notAuthorized,
    forceDisc,
    clientName,
    orderList,
  } = state;

  const api = {
    ...state,
    ...props,
    exBio: state.profileBio,
    exImage: state.profileImage,
    settings: state.exhibitorSettings,
    displayName: clientName,
    videoRequestResponse,
    setMessageSeen,
    navigate,
    tryReconnect,
    selectChat,
    toggleFilter: () => setState({ ...stateRef.current, peopleFilter: stateRef.current.peopleFilter == "EXHIBITORS" ? "ATTENDEES" : "EXHIBITORS" }),
    closeVideoCall,
    hubConnection: hubConnectionRef.current,
    savePersonalSettings,
    onEdit: editSettings,
    onSave: saveSettings,
    exBio: state.profileBio,
    exImage: state.profileImage,
    onDelete: deleteSettings,
    onAdd: addSetting,
    like,
    videoRequest,
  };

  //I have no idea where this prop is set. So until I found it, this line stands
  delete api.message;
  if (notAuthorized === true) return <NotAuthorized />;
  if (forceDisc && !connected) return <ClientConnectionFallback {...api} />;
  if (orderList.length == 0) return null;
  return (
    <div>
      <Layout {...api} />
      <ConnectionStatus {...api} />
      <SoundNotification {...api} />
    </div>
  );
};
